import { getConfig } from "./config";
import { fetchAuthSession } from 'aws-amplify/auth';

export const request = async (endpoint, options = {}) => {
  const cfg = await getConfig();
  const baseURL = cfg.poln.poln_api_base_url

  const {
    method = 'GET',
    body = null,
    queryParams = {},
    headers = {},
    skipRequestCasting = false,
    skipThrow = false,
    responseCasting = true,
    accessToken = null
  } = options;

  const session = accessToken && { tokens: { accessToken } } || await fetchAuthSession();

  const token = session.tokens?.accessToken.toString();

  const url = new URL(`${baseURL}${endpoint}`);
  Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));

  const config = {
    method,
    headers: {
      ...(token ? { 'Authorization': token } : {}),
      ...(skipRequestCasting ? {} : { 'Content-Type': 'application/json' }),
      ...headers,
    },
    body: body ? (skipRequestCasting ? body : JSON.stringify(body)) : null,
  };
  let response;

  try {
    response = await fetch(url, config);
    if (!responseCasting) return response;

    if (!response.ok) {
      const text = await response.text();
      const textJson = JSON.parse(text)

      if (skipThrow) return {
        body: textJson,
        statusCode: response.status,
        ok: response.ok,
      };

      throw new Error(textJson.message);
    }

    const data = await response.json();

    return {
      body: data,
      statusCode: response.status,
      ok: response.ok,
    };
  } catch (error) {
    if (skipThrow) return { error: error.message };
    throw new Error(`Error: ${error.message}`);
  }
};